<script lang="ts">
import Vue, { CreateElement, PropType, RenderContext, VNode } from 'vue';

import { Nullable } from '@/utils/types';
import { getBuildingDimensionLabel } from '@/bundles/MeasurementUnits/helpers/format/getBuildingDimensionLabel';

export default Vue.extend({
  name: 'BuildingDimensionLabel',

  functional: true,

  props: {
    value: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: 0
    }
  },

  render (h: CreateElement, ctx: RenderContext): VNode {
    const label = getBuildingDimensionLabel(ctx.props.value);

    if (!label) {
      return h('span', { class: 'na' }, 'N/A');
    }

    return h('span', label);
  }
});
</script>
